import axios from "axios";
import { baseurl } from "./url";
const API = axios.create({ baseURL: `${baseurl}/auth/admin` });

export const adminlogin = ({ data }) => API.post("/", data);